<!--模板-->
<template>
    <div id="error">
  error
    </div>
</template>


<!--JS-->
<script>
  export default {
    data() {
      return {}
    }
  }
</script>


<!--css样式-->
<style lang="scss" scoped>



</style>



// WEBPACK FOOTER //
// src/components/error.vue